module.exports = __webpack_public_path__ + "assets/img/heroBusiness_b.32e66a30.jpg";